import { ProfileIdentificationStatusAPIModel } from '@/generated/api/fps/api';
import { VerificationApi } from '@/generated/api/fps/core';

import { coreConfigurationFactory } from './utils/auth.provider';

const verificationApi = new VerificationApi(coreConfigurationFactory('auth'));

export const queryVerificationStatus = async (): Promise<ProfileIdentificationStatusAPIModel> =>
  ProfileIdentificationStatusAPIModel[(await verificationApi.getVerificationStatus()).status];
